var React = require('react');

function IconInfoCircleSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M510.6 65.6c-245.8 0-445 199.2-445 445s199.2 445 445 445 445-199.3 445-445c0-245.8-199.2-445-445-445zm1.3 218.8c23.8 0 43.1 19.3 43.1 43.2s-19.3 43.2-43.1 43.2-43.1-19.3-43.1-43.2 19.3-43.2 43.1-43.2zM606.7 732H417.1v-53.7h68.3V468.9h-68.3v-53.7l121.3-.7v263.8h68.3V732z"}));
}

IconInfoCircleSolid.displayName = "IconInfoCircleSolid";

IconInfoCircleSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconInfoCircleSolid;

IconInfoCircleSolid.default = IconInfoCircleSolid;
